<template>
    <header
        class="fixed top-0 left-0 right-0 z-50 transition-all duration-300"
        :class="scrolled ? 'bg-background/95 backdrop-blur-md border-b border-border shadow-sm' : 'bg-transparent'"
    >
        <div class="container mx-auto px-4 h-16 flex items-center justify-between">
            <div class="flex items-center gap-3">
                <img v-if="brandLogo" :src="brandLogo" alt="" class="h-12 w-auto shrink-0" />
                <div class="flex flex-col">
                    <!-- prefix и accent впритык (Vue condense убирает перенос между элементами);
                         пробел между ними — дело контента, например хвостовой в prefix -->
                    <span class="text-xl font-bold text-foreground tracking-tight font-heading">
                        <span>{{ brandPrefix }}</span>
                        <span class="text-gradient-blue">{{ brandAccent }}</span>
                    </span>
                    <span v-if="brandSubtitle" class="text-[10px] text-muted-foreground -mt-1 hidden sm:block">
                        {{ brandSubtitle }}
                    </span>
                </div>
            </div>

            <nav class="hidden md:flex items-center gap-6">
                <button
                    v-for="(link, i) in nav"
                    :key="i"
                    type="button"
                    class="text-sm transition-colors text-muted-foreground hover:text-accent"
                    @click="scrollTo(link.anchor)"
                >
                    {{ link.label }}
                </button>
            </nav>

            <div class="hidden md:flex items-center gap-3">
                <a
                    :href="loginUrl"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="px-4 py-2 rounded-md text-sm border border-input bg-background text-foreground hover:bg-accent hover:text-accent-foreground transition-colors"
                >
                    {{ loginLabel }}
                </a>
                <a
                    v-if="demoUrl"
                    :href="demoUrl"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="px-4 py-2 rounded-md text-sm font-semibold bg-accent text-accent-foreground hover:bg-accent/90 transition-colors"
                >
                    {{ demoLabel }}
                </a>
            </div>

            <button type="button" class="md:hidden text-foreground" aria-label="Меню" @click="mobileOpen = !mobileOpen">
                <BlockIcon :name="mobileOpen ? 'X' : 'Menu'" :size="24" />
            </button>
        </div>

        <div
            v-if="mobileOpen"
            class="md:hidden bg-background/98 backdrop-blur-md border-t border-border px-4 py-4 space-y-3"
        >
            <button
                v-for="(link, i) in nav"
                :key="i"
                type="button"
                class="block text-sm py-2 w-full text-left text-muted-foreground"
                @click="scrollTo(link.anchor)"
            >
                {{ link.label }}
            </button>
            <div class="flex gap-3 pt-2">
                <a
                    :href="loginUrl"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="flex-1 text-center px-4 py-2 rounded-md text-sm border border-input bg-background text-foreground"
                >
                    {{ loginLabel }}
                </a>
                <a
                    v-if="demoUrl"
                    :href="demoUrl"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="flex-1 text-center px-4 py-2 rounded-md text-sm font-semibold bg-accent text-accent-foreground"
                >
                    {{ demoLabel }}
                </a>
            </div>
        </div>
    </header>
</template>

<script>
import BlockIcon from "./BlockIcon.vue";
import { chromeDefaults } from "./chromeDefaults.js";

export default {
    name: "LandingHeader",
    components: { BlockIcon },
    props: { chrome: { type: Object, default: () => ({}) } },
    data() {
        return { scrolled: false, mobileOpen: false };
    },
    computed: {
        brandPrefix() {
            return this.chrome.brand_prefix ?? chromeDefaults.brand_prefix;
        },
        brandAccent() {
            return this.chrome.brand_accent ?? chromeDefaults.brand_accent;
        },
        brandSubtitle() {
            return this.chrome.brand_subtitle ?? chromeDefaults.brand_subtitle;
        },
        // Пустое поле формы приезжает null (см. demoUrl) — без знака, как раньше.
        brandLogo() {
            return this.chrome.brand_logo || "";
        },
        nav() {
            return this.chrome.nav && this.chrome.nav.length ? this.chrome.nav : chromeDefaults.nav;
        },
        loginUrl() {
            return this.chrome.login_url ?? chromeDefaults.login_url;
        },
        loginLabel() {
            return this.chrome.login_label ?? chromeDefaults.login_label;
        },
        // Кнопка демо — опциональная: пустой URL в админке означает «без кнопки».
        // Пустая строка из формы приезжает с бэка как null (ConvertEmptyStringsToNull),
        // поэтому дефолт не подставляем — иначе очищенное поле воскрешало бы кнопку.
        demoUrl() {
            return this.chrome.demo_url || "";
        },
        demoLabel() {
            return this.chrome.demo_label || chromeDefaults.demo_label;
        },
    },
    mounted() {
        window.addEventListener("scroll", this.onScroll, { passive: true });
        this.onScroll();
    },
    beforeUnmount() {
        window.removeEventListener("scroll", this.onScroll);
    },
    methods: {
        onScroll() {
            this.scrolled = window.scrollY > 20;
        },
        scrollTo(anchor) {
            this.mobileOpen = false;
            if (!anchor) {
                return;
            }
            const el = document.querySelector(anchor);
            if (el) {
                el.scrollIntoView({ behavior: "smooth" });
            }
        },
    },
};
</script>
